"use client";

/** Toast / notification inside modal */
export function PaletteToast({
  message,
  onDismiss,
}: {
  message: string | null;
  onDismiss: () => void;
}) {
  if (!message) return null;
  return (
    <div className="flex items-center justify-between border-b border-violet-500/30 bg-violet-950/80 px-4 py-2 text-xs font-medium text-violet-200">
      <span>{message}</span>
      <button
        type="button"
        onClick={() => onDismiss()}
        className="text-violet-400 hover:text-white"
      >
        ✕
      </button>
    </div>
  );
}
